export default __webpack_public_path__ + "static/media/copySync_screenshot.1027001f.png";